module.exports = __webpack_public_path__ + "static/media/12.2c449fd9.svg";